export function isAbTestingBannerEmpty(props) {
    return !props.testId || !props.bannerA || !props.bannerB;
}
